import React from "react";
import { NavLink } from "react-router-dom";
import { AdminGuard, SupplierGuard } from "../../guards/RolesGuard";
import { classNames } from "../../utils/classNames";
import { useGetCurrentUserQuery } from "../../store/user/userApi";

let navigationAgents = [
  {
    name: "Purchase Orders",
    href: "/purchase-orders",
    icon: <img alt="purchase-orders" src="/assets/navigation/purchase.svg" />,
    enabled: true,
  },
  {
    name: "Reservations",
    href: "/reservations",
    icon: <img alt="reservations" src="/assets/navigation/ai-reservations.svg" />,
    enabled: true,
  },
  {
    name: "Rooms Requests",
    href: "/room-request",
    icon: <img alt="reservations" src="/assets/navigation/room-service.svg" />,
    enabled: true,
  },
  {
    name: "Drafts",
    href: "/drafts",
    icon: <img alt="reservations" src="/assets/navigation/ai-reservations.svg" />,
    enabled: true,
  },
  {
    name: "Calls",
    href: "/calls",
    icon: <img alt="reservations" src="/assets/navigation/ai-reservations.svg" />,
    enabled: true,
  },
  {
    name: "Users",
    href: "/users",
    icon: <img alt="reservations" src="/assets/navigation/partners.svg" />,
    enabled: true,
  },
  {
    name: "Suppliers",
    href: "/suppliers",
    icon: <img alt="supplirs" src="/assets/navigation/partners.svg" />,
    enabled: true,
  },
  {
    name: "Settings",
    href: "/settings",
    icon: <img alt="settings" src="/assets/navigation/ai-reservations.svg" />,
    enabled: true,
  },
];

const navigationSupplier = [
  {
    name: "Invoices",
    href: "/invoices",
    icon: <img alt="invoices" src="/assets/navigation/invoices.svg" />,
    enabled: true,
  },
];

const navigationAdmin = [
  {
    name: "Users",
    href: "/users",
    icon: <img alt="users" src="/assets/navigation/partners.svg" />,
    enabled: true,
  },
];

const Navigation = () => {
  const isAdmin = AdminGuard();
  const isSupplier = SupplierGuard();
  const {data: user} = useGetCurrentUserQuery();

  navigationAgents = ['mrchow', 'casadino', 'beautysaloon'].includes(user?.username || '') ? navigationAgents.filter(nav => nav.name.toLowerCase() === 'calls') : navigationAgents
  return (
    <>
      {isAdmin ? (
        <>
          {navigationAdmin.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                classNames(
                  "text-base text-secondary group flex items-center px-2 py-2 font-medium rounded-md mb-2",
                  item.enabled && isActive
                    ? "font-dm_sans_bold"
                    : "font-dm_sans_regular"
                )
              }
            >
              {/* <item.icon className="mr-3 flex-shrink-0 h-6 w-6 text-indigo-300" aria-hidden="true" /> */}
              {item.icon ? (
                <span className="flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center">
                  {React.cloneElement(item.icon, { width: 20, height: 20 })}
                </span>
              ) : (
                <span className="flex w-8" />
              )}
              {item.name}
            </NavLink>
          ))}
        </>
      ) : (
        <>
          {isSupplier ? (
            <>
              {navigationSupplier.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={({ isActive }) =>
                    classNames(
                      "text-base  group flex items-center px-2 py-2 font-medium rounded-md mb-2 font-dm_sans_regular",
                      item.enabled && isActive
                        ? "bg-[#E8F1FD] text-primary-default"
                        : "text-secondary"
                    )
                  }
                >
                  {/* <item.icon className="mr-3 flex-shrink-0 h-6 w-6 text-indigo-300" aria-hidden="true" /> */}
                  <span className="flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center">
                    {React.cloneElement(item.icon, { width: 20, height: 20 })}
                  </span>
                  {item.name}
                </NavLink>
              ))}
            </>
          ) : (
            <>
              {navigationAgents.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={({ isActive }) =>
                    classNames(
                      "text-base group flex items-center px-2 py-2 font-medium rounded-md mb-2 font-dm_sans_regular",
                      item.enabled && isActive
                        ? "bg-[#E8F1FD] text-primary-default"
                        : "text-secondary"
                    )
                  }
                >
                  {/* <item.icon className="mr-3 flex-shrink-0 h-6 w-6 text-indigo-300" aria-hidden="true" /> */}
                  {item.icon ? (
                    <span className="flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center">
                      {React.cloneElement(item.icon, { width: 20, height: 20 })}
                    </span>
                  ) : (
                    <span className="flex w-8" />
                  )}
                  {item.name}
                </NavLink>
              ))}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Navigation;
